<template>
  <div class="sc-message">
    <div class="sc-message--content sent carousel ml-auto justify-end">
      <div class="sc-message--text w-full sc-message-bubble sent relative subpixel-antialiased"
           :style="styles"
      >
        <p class="sc-message--text-content m-0" :style="{fontFamily: themeConfig.font}">
          {{ text }}
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ChatPreviewClientMessage',

  props: {
    themeConfig: {
      type: Object,
      required: true
    },
    text: {
      type: String,
      default: ''
    }
  },

  computed: {
    styles() {
      return {
        background: this.themeConfig.sentMessage.bg,
        color: this.themeConfig.sentMessage.text,
        fontSize: this.themeConfig.messageBubble.fontSize,
        fontWeight: this.themeConfig.messageBubble.fontWeight,
        width: this.themeConfig.messageBubble.width,
        padding: this.themeConfig.messageBubble.paddingText,
        lineHeight: this.themeConfig.messageBubble.lineHeight
      }
    }
  }
}
</script>
